import useTenant from '@/hooks/useTenant'
import { Alert, Box, Button, Stack, Typography, useTheme } from '@mui/material'
import Image from 'next/image'
import { PageType } from '.'
import platesImage from './3-plates.png'
import { NO_ACCOUNT_FOUND_ERROR, SIGN_UP_DISABLED } from './rules'

type Props = {
  pageType: PageType
  ssoEnabled?: boolean
  accountNotFound?: boolean
  onSubmit: () => void
  loading: boolean
}

const WelcomeScreen = (props: Props) => {
  const theme = useTheme()
  const tenant = useTenant()
  const { accountNotFound, ssoEnabled = false, onSubmit = () => null, loading } = props

  return (
    <Stack spacing={0}>
      <Box position="relative" height={330}>
        <Image src={platesImage.src} fill alt="3 plates" objectFit="contain" />
      </Box>

      <Stack spacing={2} pt={2} pb={8} px={{ xs: 4, md: 6 }}>
        <Stack spacing={2} textAlign="center">
          <div>
            <Typography variant="h4" fontWeight="400" color="coal">
              It’s time to eat better at{' '}
              <Typography variant="h3" component="span" color="primary" fontWeight="400">
                work
              </Typography>
            </Typography>
          </div>

          <Typography color={theme.palette.text.secondary}>
            {tenant.name} makes it easy for you to eat exactly how you want when you’re at work, no
            matter your food goals. Sign up to access daily menus, delivered to your office.
          </Typography>

          <Button
            fullWidth
            size="large"
            type="submit"
            variant="contained"
            disabled={ssoEnabled || accountNotFound}
            onClick={onSubmit}
            sx={{ marginTop: '16px' }}
            data-testid="signup-get-started-button"
            loading={loading}
          >
            Get started
          </Button>

          {!loading && ssoEnabled && (
            <Alert icon={false} severity="error">
              {SIGN_UP_DISABLED}
            </Alert>
          )}

          {!loading && accountNotFound && (
            <Alert icon={false} severity="error">
              {NO_ACCOUNT_FOUND_ERROR}
            </Alert>
          )}
        </Stack>
      </Stack>
    </Stack>
  )
}

export default WelcomeScreen
